var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYanganqixianlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_40983)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7.5,
    width: 9,
    height: 2,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97564 13.5L1.11849 9.5H8.88151L8.02436 13.5H1.97564Z",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5V12.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5V12.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5V12.5",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7V1.5H16",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7V1.5H17.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7V4H19.5",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_40983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYanganqixianlu);
export default __webpack_public_path__ + "static/media/yanganqixianlu.18ff7fb2e74f7e1e7490a699f67d07df.svg";
export { ForwardRef as ReactComponent };